import { applyLoanToRNPL } from "../api/requests"
import { showToast } from "../utils/miscFunctions"

function useRNPL() {

    const handleApplyLoanToRNPL = (rnplId: string, onSuccess: () => void) => {
        try {
            const response: any = applyLoanToRNPL(rnplId)
            if (response) {
                showToast.success(response?.message || "Loan applied successfully")
                onSuccess()
            }
        } catch (error: any) {
            showToast.error(error?.description || "Error applying loan to RNPL")
        }
    }
    return {
        handleApplyLoanToRNPL
    }
}

export default useRNPL;